import React, { useContext, useEffect } from "react";
import BarCompare from "../comparisoncharts/BarCompare";
import LineCompare from "../comparisoncharts/LineCompare";
import PieCompare from "../comparisoncharts/PieCompare";
import GaugeCompare from "../comparisoncharts/GaugeCompare";
import { StoreContext } from "../store/Store";
import Loader from "./Loader/Loader";

const CompareChartComponents = () => {
  const { getParentComparison, comparisonMetrics, loading } =
    useContext(StoreContext);

  const configid = localStorage.getItem("configid");
  useEffect(() => {
    getParentComparison(configid);
  }, [configid]);

  const renderChart = (chartType, metricData, i) => {
    switch (chartType) {
      case "Bar Chart":
        return <BarCompare key={i} metricData={metricData} />;
      case "Pie Chart":
        return <LineCompare key={i} metricData={metricData} />;
      case "Donut Chart":
        return <PieCompare key={i} metricData={metricData} />;
      case "Line Chart":
        return <GaugeCompare key={i} metricData={metricData} />;
      default:
        return <p key={i}>No chart type found for {chartType}</p>;
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="dashboard" style={{ minHeight: "80.5vh" }}>
      <div>
        <p className="mb-0 badge text-lg fw-medium px-10 py-9 radius-4 text-secondary">
          AI Comparison Metrics
        </p>
      </div>
      <div className="level0Metrics row g-3">
        {comparisonMetrics
          ?.filter(
            (filterItem) =>
              filterItem.value && Object.keys(filterItem.value).length > 0
          )
          ?.map((item, i) => (
            <div className="level0Metric col-12 col-md-6" key={i}>
              {renderChart(item.comparison_chart_type, item, i)}
            </div>
          ))}
      </div>
    </div>
  );
};

export default CompareChartComponents;
